import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@shared';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { PermissionsState } from '@app/core/store/permissions/permissions.reducer';
import { loadPermissionsSuccess } from '@app/core/store/permissions/permissions.actions';
import { IPermissions } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  permissions$: Observable<any>;
  permissionKey: string = environment.permissionKey;
  constructor(
    private http: HttpClient,
    private _ngxPermissionService: NgxPermissionsService,
    private _store: Store<{
      permissions: PermissionsState;
    }>,
  ) {
    this.permissions$ = this._store.select((state) => state.permissions.permissions);
  }

  getAllPermissions(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('v1/admin/system-admin/getPermissions');
  }

  setPermissions(permissions: IPermissions[]) {
    this._store.dispatch(loadPermissionsSuccess({ permissions }));
    this.loadPermissions();
  }
  addPermissions() {
    let allPermisisonsData: string[] = [];
    this.permissions$.subscribe((data) => {
      allPermisisonsData = data.map((module: { moduleKey: string; read: boolean; write: boolean }) =>
        module.write && module.read
          ? module.moduleKey + '_read_write'
          : module.read && !module.write
            ? module.moduleKey + '_read'
            : module.moduleKey,
      );
    });
    return allPermisisonsData;
  }

  loadPermissions() {
    this._ngxPermissionService.flushPermissions();
    this._ngxPermissionService.loadPermissions(this.addPermissions());
  }
}
